import $ from 'jquery';

$('.dsp-toggle').on('click', function (e) {
  e.stopPropagation();

  const toggle = $(this);

  const toggleID = toggle.data('toggle-target');
  const toggleGroup = toggle.data('toggle-group');
  const selfCollapse = typeof toggle.data('self-collapse') !== undefined;

  let wasActive = false;
  if (selfCollapse) {
    wasActive = toggle.hasClass('is-active');
  }

  // reset all toggles and panes
  $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');

  if (!wasActive) {
    // grab all toggles that control this toggleID
    const toggles = $(`[data-toggle-target=${toggleID}]`);

    // activate all linked toggles
    toggles.each(function () {
      $(this).addClass('is-active');
    });

    // activate the target pane(s)
    const targets = $(`.${toggleID}`);
    targets.each(function () {
      $(this).addClass('is-active');
    });

    $(`#${toggleID}`).addClass('is-active');
  }
});

$('.dsp-toggle-all-on').on('click', function (e) {
  e.stopPropagation();
  const toggle = $(this);
  const toggleGroup = toggle.data('toggle-group');
  $(`[data-toggle-group=${toggleGroup}]`).addClass('is-active');
});

$('.dsp-toggle-all-off').on('click', function (e) {
  e.stopPropagation();
  const toggle = $(this);
  const toggleGroup = toggle.data('toggle-group');
  $(`[data-toggle-group=${toggleGroup}]`).removeClass('is-active');
});

// Header Toggle Sync
$('.header .search__input').on('keyup', function () {
  const searchText = $(this).val();
  const searchInputs = $('.header .search__input');
  searchInputs.each(function () {
    $(this).val(searchText);
  });
});
